// TSS vite/04 §"Endpoint paths".
// URL knowledge lives here: a backend rename touches one file.
// No leading slash — axios joins baseURL + url with a single slash.

export const teamPaths = {
    list:    ()             => 'admin/teams',
    detail:  (id)           => `admin/teams/${id}`,
    members: (id)           => `admin/teams/${id}/members`,
    member:  (id, userId)   => `admin/teams/${id}/members/${userId}`,
};
